import { Navigate, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { isExecutive, isOwner, isOwnerOnlyPath, can, permissionForPath, firstAllowedRoute } from '../utils/permissions'

function ProtectedRoute({ children, requires }) {
  const location = useLocation()
  const { isAuthenticated } = useSelector((state) => state.auth)

  if (!isAuthenticated) {
    return <Navigate to="/admin" replace />
  }

  if (sessionStorage.getItem('needPasswordChange') === 'true') {
    return <Navigate to="/admin/change-password" replace />
  }

  // Owner-only pages (settlement, carousel, game priority): staff and
  // executives are bounced no matter how they got the URL. Neither bounce
  // target is itself owner-only, so this can't redirect-loop.
  if (isOwnerOnlyPath(location.pathname) && !isOwner()) {
    return <Navigate to={isExecutive() ? firstAllowedRoute() : '/admin/home'} replace />
  }

  // Executive gate (client UX only — the API enforces for real). The optional
  // `requires` prop overrides the path table for routes the prefix map can't
  // express. The target !== pathname check prevents an infinite redirect loop
  // when the landing target is itself the denied route.
  if (isExecutive()) {
    const requiredKey = requires || permissionForPath(location.pathname)
    if (requiredKey && !can(requiredKey)) {
      const target = firstAllowedRoute()
      if (target !== location.pathname) {
        return <Navigate to={target} replace />
      }
    }
  }

  return children
}

export default ProtectedRoute
